import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ThemeService } from '../services/themes.service';

@Component({
    selector: 'app-chatbot',
    templateUrl: './chatbot.component.html',
    styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {

    themedata: any;
    messageForm: UntypedFormGroup = new UntypedFormGroup({});

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ChatbotComponent>,
        private formBuilder: UntypedFormBuilder,
        private themeService: ThemeService,
    ) {
        this.messageForm = this.formBuilder.group({
            message: [],
        });
    }

    ngOnInit(): void {
        this.themeService.theme$.subscribe((response) => {
            this.themedata = response;
        });
    }

    closeChatModal() {
        this.dialogRef.close();
    }

    sendMessage() {
        const message = this.messageForm.get('message')?.value;
    }
}
